import React from "react";

export default function Loader() {
  return (
    <div className="col">
      <div
        className="d-flex justify-content-center"
        data-aos="fade"
        data-aos-duration="1000"
        data-aos-once="true"
      >
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  );
}
